import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=68ba7800&scoped=true&"
import script from "./EditOrder.vue?vue&type=script&lang=ts&"
export * from "./EditOrder.vue?vue&type=script&lang=ts&"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=68ba7800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba7800",
  null
  
)

export default component.exports